import { styled } from "styled-components";

export const Divider = styled.hr`
    border: none;
    height: 1px;
    background-color: #E8E8E8;
`
